import React, { Component } from "react";
import { View } from "react-native";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import { BottomPopInputInstance } from "./BottomPopInput";
import { BottomPopExplanationInstance } from "./BottomPopExplanation";

import {ViewPropTypes, ImagePropTypes, TextPropTypes} from "deprecated-react-native-prop-types";

/**
 * the root container to contain the bottom input pop for reuse
 */
class BottomInputRoot extends Component {
    render() {
        return (
            <View ref={c => (this._root = c)} {...this.props} style={{ flex: 1 }}>
                {this.props.children}
                <CommonModal
                    childRef={ref => {
                        if (ref) {
                            BottomInputRoot.commonModalRef = ref;
                        }
                    }}
                />
                <BottomPopInputInstance
                    ref={c => {
                        if (c) {
                            BottomPopInputInstance.BottomPopInputInstanceE = c;
                        }
                    }}
                />
                <BottomPopExplanationInstance
                    ref={c => {
                        if (c) {
                            BottomPopExplanationInstance.BottomPopExplanationInstanceE = c;
                        }
                    }}
                />
            </View>
        );
    }
}

BottomInputRoot.propTypes = {
    ...ViewPropTypes,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
};
export { BottomInputRoot };
